<div class="content-body">
  <div class="row">
    <div class="col-lg-12">
      <p class="disinfo">Invoice Information</p>
      <ng-container *ngIf="disputeData">
      <p style="border-bottom: 1px solid #d1d1d1; padding-top: 5px">Details</p>

      <div class="row d-flex justify-content-between mt-4 mb-3 invoice-details-section-1">
        <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
          <h6>Account No.</h6>
          <p>{{ disputeData.bpNo }}</p>
        </div>
        <ng-container *ngIf="isInvoiceDispute">
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Invoice No.</h6>
            <p>{{ disputeData.invoice_id }}</p>
          </div>
  
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Bill Date</h6>
            <p>{{ disputeData.date | date : "MM/dd/yyyy" }}</p>
          </div>
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Due Date</h6>
            <p>{{ disputeData.dueDate | date : "MM/dd/yyyy" }}</p>
          </div>
        </ng-container>
      </div>
    </ng-container>
      <p style="border-bottom: 1px solid #d1d1d1">Address</p>

      <div class="row d-flex justify-content-between mt-4 mb-3 invoice-details-section-2">
        <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
          <h6>From</h6>
            Brightspeed<br />
            P.O. Box 2677<br />
            Fayetteville, NC 28302-2677
        </div>
        <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head" *ngIf="disputeData && isInvoiceDispute">
          <h6>To</h6>
            {{ disputeData.businessPartnerName }}<br />
            {{ disputeData.StreetName }}<br />
            {{ disputeData.CityName }}, {{ disputeData.zipCode }}<br />
            {{ disputeData.Country }}
        </div>

        <div class="col-sm-12 col-md-3 desktop-view"></div>
        <div class="col-sm-12 col-md-3 desktop-view"></div>
      </div>
    </div>
  </div>

  <form class="g-2 mt-4 gx-5 formcss">
    <div class="me-auto d-flex justify-content-between">
      <p class="disinfo me-auto">Dispute Information</p>
      <a (click)="editdispute()" class="text-black ac-text-decoration me-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path
            d="M200-200h56l345-345-56-56-345 345v56Zm572-403L602-771l56-56q23-23 56.5-23t56.5 23l56 56q23 23 24 55.5T829-660l-57 57Zm-58 59L290-120H120v-170l424-424 170 170Zm-141-29-28-28 56 56-28-28Z"
          />
        </svg>
      </a>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div *ngIf="disputeFormData.iNumber && isInvoiceDispute"
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Invoice Number</h6>
          <p>{{ disputeFormData.iNumber }}</p>
        </div>
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Disputed Amount</h6>
          <p>
            <span class="font-w600">{{ currency | currencySymbol }}</span>
            {{ disputeFormData.amount | number : "1.2-2" }}
          </p>
        </div>
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Dispute Type</h6>
          <p>{{ disputeFormData.typeValue }}</p>
        </div>

        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Priority</h6>
          <p>{{ disputeFormData.priorityValue }}</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
          *ngIf="disputeFormData.itemNumber != ''"
        >
          <label class="pb-2">Item Number</label>
          <p>{{ disputeFormData.itemNumber }}</p>
        </div>

        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Reason</h6>
          <p>{{ disputeFormData.reasonValue }}</p>
        </div>
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
          *ngIf="disputeFormData.fileName"
        >
          <h6>Attachement</h6>
          <p>{{ disputeFormData.fileName }}</p>
        </div>
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inner-head ac-inv-head"
        >
          <h6>Customer Note</h6>
          <p>{{ disputeFormData.note }}</p>
        </div>
      </div>
    </div>
    <div class="form-group m-4 pb-1" style="text-align: end">
      <button
        class="btn ac-btn-primary mb-sm-0 mb-2 float-right"
        (click)="createDispute(successDisputeModal)"
      >
        Submit
      </button>
    </div>
  </form>
</div>
<ng-template #successDisputeModal let-modal>
  <div class="modal-body">
    <div *ngIf="showLoader && !showError">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="58"
        height="104"
        viewBox="0 0 58 104"
        fill="none"
      >
        <path
          d="M52 98C26.5949 98 6 77.4051 6 52C6 26.5949 26.5949 6 52 6"
          stroke="url(#paint0_linear_313_43230)"
          stroke-width="12"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_313_43230"
            x1="29"
            y1="6"
            x2="29"
            y2="98"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FA783C" />
            <stop offset="1" stop-color="#FFC800" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div *ngIf="!showLoader && !showError">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
      >
        <path
          d="M36 0C16.2 0 0 16.2 0 36C0 55.8 16.2 72 36 72C55.8 72 72 55.8 72 36C72 16.2 55.8 0 36 0ZM28.8 54L10.8 36L15.876 30.924L28.8 43.812L56.124 16.488L61.2 21.6L28.8 54Z"
          fill="#168007"
        />
      </svg>
    </div>
    <div *ngIf="showError">
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z"
          fill="#D30000"
        />
      </svg>
    </div>
    <h4 class="mt-3" style="font-size: 24px">{{ message }}</h4>
    <p [innerHtml]="textMsg"></p>
    <button
      type="button"
      class="close btn ac-btn-outline-primary ac-butncancel"
      aria-label="Close"
      (click)="closeDisputePopup()"
    >
      Close
    </button>
  </div>
</ng-template>
